import styled from "styled-components";

import icon_book from "assets/images/franchising2024/icons/book.png";
import icon_enginer from "assets/images/franchising2024/icons/enginer.png";
import icon_market from "assets/images/franchising2024/icons/market.png";
import icon_paint from "assets/images/franchising2024/icons/paint.png";
import icon_tech from "assets/images/franchising2024/icons/tech.png";

export const Container = styled.section`
    display:flex;
    flex-wrap: wrap;
    width: 100%
    height: auto;
    background:#e3e3e3;
    padding:100px 20px;
`;

export const GroupCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1100px;
  height: auto;
  column-gap: 20px;
  padding-left: 100px;

  @media screen and (max-width: 1720px) {
    padding-left: 0;
    margin: 0 auto;
  }
  @media screen and (max-width: 1024px) {
    max-width: 800px;
    row-gap: 50px;
  }
  @media screen and (max-width: 690px) {
    width: max-content;
    max-width: 550px;
    align-items: center;
    justify-content: center;
  }
`;

export const Card = styled.div`
  width: 100%;
  max-width: 315px;
  height: auto;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  @media screen and (max-width: 690px) {
    align-items: center;
    justify-content: center;
  }

  div.orange_ball {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background: #ee692f;
    margin: 0 auto 30px auto;
    div.black_ball {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 150px;
      height: 150px;
      background: #000;
      border-radius: 50%;
    }
  }
  h3 {
    margin-bottom: 15px;
    color: #000;
  }
  p {
    margin-bottom: 10px;
    color: #000;
  }
  p::before {
    content: "✓ ";
    color: #ee692f; /* opcional: cor do símbolo */
    margin-right: 2px; /* espaçamento entre o símbolo e o texto */
    font-weight: bold; /* opcional: deixa o símbolo mais visível */
  }
`;

export const IconBook = styled.img.attrs({ src: icon_book })`
  width: 70px;
  height: auto;
`;
export const IconEnginer = styled.img.attrs({ src: icon_enginer })`
  width: 70px;
  height: auto;
`;
export const IconMarket = styled.img.attrs({ src: icon_market })`
  width: 70px;
  height: auto;
`;
export const IconPaint = styled.img.attrs({ src: icon_paint })`
  width: 70px;
  height: auto;
`;
export const IconTech = styled.img.attrs({ src: icon_tech })`
  width: 70px;
  height: auto;
`;
